const megamenus = document.querySelectorAll(".megamenu-js");

megamenus.forEach((element) => {
  element.addEventListener("mouseenter", (e) => {
    const megamenu = getMegamenu(element);
    if (megamenu) {
      megamenu.classList.remove("hide");
      megamenu.classList.remove("we-megamenu-fadeout");
      megamenu.classList.add("we-megamenu-fadein");
    }
  });

  element.addEventListener("mouseleave", (e) => {
    const megamenu = getMegamenu(element);
    if (megamenu) {
      megamenu.classList.remove("we-megamenu-fadein");
      megamenu.classList.add("we-megamenu-fadeout");
    }
  });
});

function getMegamenu(element) {
  let megamenu = element.querySelector(".wesite_megamenu");
  return megamenu;
}
